import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enCommon from '../locales/en/common.json';
import enNav from '../locales/en/nav.json';
import enSettings from '../locales/en/settings.json';
import enAuth from '../locales/en/auth.json';
import enPublic from '../locales/en/public.json';
import enOnboarding from '../locales/en/onboarding.json';
import enLegal from '../locales/en/legal.json';
import enDashboard from '../locales/en/dashboard.json';
import enTasks from '../locales/en/tasks.json';
import enTimeReport from '../locales/en/timeReport.json';
import enUsers from '../locales/en/users.json';
import enRoles from '../locales/en/roles.json';
import enLocations from '../locales/en/locations.json';
import enCustomers from '../locales/en/customers.json';
import enArticles from '../locales/en/articles.json';
import enTaskLog from '../locales/en/taskLog.json';
import enCompany from '../locales/en/company.json';
import enExport from '../locales/en/export.json';
import enAnalytics from '../locales/en/analytics.json';
import enCompanies from '../locales/en/companies.json';
import enSuperAdmin from '../locales/en/superAdmin.json';
import enHandouts from '../locales/en/handouts.json';
import enWorkGroups from '../locales/en/workGroups.json';
import enPresets from '../locales/en/presets.json';
import enWorkHourRules from '../locales/en/workHourRules.json';
import enSupport from '../locales/en/support.json';
import svCommon from '../locales/sv/common.json';
import svNav from '../locales/sv/nav.json';
import svSettings from '../locales/sv/settings.json';
import svAuth from '../locales/sv/auth.json';
import svPublic from '../locales/sv/public.json';
import svOnboarding from '../locales/sv/onboarding.json';
import svLegal from '../locales/sv/legal.json';
import svDashboard from '../locales/sv/dashboard.json';
import svTasks from '../locales/sv/tasks.json';
import svTimeReport from '../locales/sv/timeReport.json';
import svUsers from '../locales/sv/users.json';
import svRoles from '../locales/sv/roles.json';
import svLocations from '../locales/sv/locations.json';
import svCustomers from '../locales/sv/customers.json';
import svArticles from '../locales/sv/articles.json';
import svTaskLog from '../locales/sv/taskLog.json';
import svCompany from '../locales/sv/company.json';
import svExport from '../locales/sv/export.json';
import svAnalytics from '../locales/sv/analytics.json';
import svCompanies from '../locales/sv/companies.json';
import svSuperAdmin from '../locales/sv/superAdmin.json';
import svHandouts from '../locales/sv/handouts.json';
import svWorkGroups from '../locales/sv/workGroups.json';
import svPresets from '../locales/sv/presets.json';
import svWorkHourRules from '../locales/sv/workHourRules.json';
import svSupport from '../locales/sv/support.json';
import { resolveLocale } from '../utils/locale';

const resources = {
  en: {
    common: enCommon,
    nav: enNav,
    settings: enSettings,
    auth: enAuth,
    public: enPublic,
    onboarding: enOnboarding,
    legal: enLegal,
    dashboard: enDashboard,
    tasks: enTasks,
    timeReport: enTimeReport,
    users: enUsers,
    roles: enRoles,
    locations: enLocations,
    customers: enCustomers,
    articles: enArticles,
    taskLog: enTaskLog,
    company: enCompany,
    export: enExport,
    analytics: enAnalytics,
    companies: enCompanies,
    superAdmin: enSuperAdmin,
    handouts: enHandouts,
    workGroups: enWorkGroups,
    presets: enPresets,
    workHourRules: enWorkHourRules,
    support: enSupport
  },
  sv: {
    common: svCommon,
    nav: svNav,
    settings: svSettings,
    auth: svAuth,
    public: svPublic,
    onboarding: svOnboarding,
    legal: svLegal,
    dashboard: svDashboard,
    tasks: svTasks,
    timeReport: svTimeReport,
    users: svUsers,
    roles: svRoles,
    locations: svLocations,
    customers: svCustomers,
    articles: svArticles,
    taskLog: svTaskLog,
    company: svCompany,
    export: svExport,
    analytics: svAnalytics,
    companies: svCompanies,
    superAdmin: svSuperAdmin,
    handouts: svHandouts,
    workGroups: svWorkGroups,
    presets: svPresets,
    workHourRules: svWorkHourRules,
    support: svSupport
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: resolveLocale(),
    fallbackLng: 'en',
    defaultNS: 'common',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
